<template>
  <a-modal
    :visible="visible"
    :footer="null"
    @cancel="handleClose"
    :mask="true"
    :maskClosable="false"
    :title="null"
    z-index="55555"
    wrapClassName="survey-form-container-modal"
  >
    <div class="survey-form-container">
      <div class="survey-form-container__header">
        <h1 class="survey-form-container__header--title">Survey Form</h1>
      </div>
      <div class="survey-form-container__body">
        <template v-if="fetchQuestionLoader">
          <a-skeleton
            v-for="index in 4"
            :key="index"
            class="survey-form-container__body--skeleton"
            active
            :title="{ width: '50%' }"
            :paragraph="{
              rows: 1,
              width: ['100%'],
            }"
          />
        </template>
        <template v-else>
          <a-form
            :model="answers"
            :rules="rules"
            ref="surveyForm"
            class="survey-form-container__body--form"
          >
            <template v-for="question in questions" :key="question.id">
              <a-form-item label-align="left" :name="`${question.id}`">
                <template #label>
                  <p class="label">{{ question.question }} <span>*</span></p>
                </template>
                <a-input
                  v-model:value="answers[`${question.id}`]"
                  placeholder="Please enter your answer"
                />
              </a-form-item>
            </template>
          </a-form>
        </template>
      </div>
      <div class="survey-form-container__footer" v-if="!fetchQuestionLoader">
        <a-button
          :loading="submitFeedbackLoader"
          :disabled="submitFeedbackLoader"
          html-type="submit"
          @click="submitSurvey"
        >
          Submit
        </a-button>
      </div>
    </div>
  </a-modal>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "GlocalFeedBackForm",
  props: {
    visible: {
      type: Boolean,
      default: () => false,
    },
  },
  emits: ["handle-close"],
  data: () => ({
    questions: [],
    fetchQuestionLoader: false,
    submitFeedbackLoader: false,
    rules: {},
    answers: {},
  }),
  computed: {
    ...mapGetters({
      authProfileSettings: 'profile/authProfileSettings',
      userId: 'auth/getUserId'
      //   questions: 'profile/getQuestions'
    }),
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
          (async () => {
            this.fetchQuestionLoader = true;
            const response = await this.fetchGlocalFormSurveyQuestions();
            this.questions = response.data.map((question, index) => ({
              ...question,
              name: `${question.question}-${index}`,
            }));
            response.data.forEach((question, index) => {
              this.rules[`${question.id}`] = [
                {
                  required: true,
                  message: "Please enter your answer",
                  trigger: "blur",
                },
              ];
              this.answers[`${question.id}`] = "";
            });
            this.fetchQuestionLoader = false;
          })(); //IIFE
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions({
      fetchGlocalFormSurveyQuestions: "profile/fetchGlocalFormSurveyQuestions",
      submitGlocalFormSurvey: "profile/submitGlocalFormSurvey",
      updateUserSettings: 'profile/updateUserSettings',
      setTriggerFeedBackForm: 'profile/setTriggerFeedBackForm',
    }),
    submitSurvey(e) {
      e.preventDefault();
      try {
        this.$refs.surveyForm
          .validate()
          .then(async () => {
            this.submitFeedbackLoader = true;
            const serializedForm = Object.entries(this.answers).map(
              ([key, value]) => {
                return { question: key, answer: value };
              }
            );
            await this.submitGlocalFormSurvey(serializedForm);
            this.$showToast({message:'Thank you for your valuable feedback.', type:'success'})
            this.closeModal();
          })
          .catch((err) => {
            this.submitFeedbackLoader = false;
          });
      } catch (err) {
        console.log(err, "ERROR");
      }
    },
    async handleClose(){
      try{
        const updatedSettings = {
          ...this.authProfileSettings,
          has_feedback_form_closed: true
        }
        this.updateUserSettings({settings: updatedSettings, user_id: this.userId})
        this.closeModal()
      }
      catch(err){
        console.log(err, "ERROR")
      }
    },
    closeModal() {
      this.$refs.surveyForm.clearValidate();
      this.$refs.surveyForm.resetFields();
      this.submitFeedbackLoader = false;
      this.$emit("handle-close");
    },
  },
};
</script>
<style lang="scss">
.survey-form-container-modal {
  .ant-modal {
    top: 8rem;
    padding-bottom: 0;
    width: 60rem !important;
    .ant-modal-content {
      padding: 0;
      background-color: $color-white;

      .ant-modal-close {
        margin: 2rem 2rem 0 0;
        .ant-modal-close-x {
          .anticon {
            font-size: 2rem;
            @include respond(phone-large) {
              font-size: 2.8rem;
            }
          }
        }
      }

      .ant-modal-body {
        .survey-form-container {
          &__header {
            padding: 2.5rem 2.5rem 2rem;
            &--title {
              font-size: 2.5rem;
              font-family: $font-primary-bold;
              color: $color-black;
              margin-bottom: 0;
              line-height: normal;
              @include respond(phone-large) {
                font-size: 3.2rem;
              }
            }
          }
          &__body {
            padding: 0 2.5rem 1.5rem;
            max-height: calc(100vh - 29rem);
            overflow-y: auto;
            overflow-x: hidden;
            @include respond(phone-large) {
              max-height: calc(100vh - 45rem);
            }
            &--form {
              display: flex;
              flex-direction: column;
              gap: 1.6rem;
              .ant-form-item {
                flex-direction: column;
                row-gap: 0.6rem !important;
                margin-bottom: 0;
                .ant-form-item-label {
                  overflow: hidden;
                  white-space: pre-line;
                  padding: 0;
                  margin: 0;
                  label {
                    height: max-content;
                    font-size: 1.6rem;
                    font-family: $font-primary;
                    line-height: 2.2rem;
                    margin: 0;
                    color: $color-black;
                    align-items: flex-start;
                    @include respond(phone-large) {
                      font-size: 2.2rem;
                      line-height: 2.8rem;
                    }
                    &::after,
                    &::before {
                      content: none;
                    }
                    p {
                      font-size: inherit;
                      line-height: inherit;
                      margin: 0;
                      span {
                        font-size: 1.6rem;
                        color: red;
                        line-height: normal;
                        @include respond(phone-large) {
                          font-size: 2.2rem;
                        }
                      }
                    }
                  }
                }
                .ant-form-item-control {
                  flex: 1;
                  .ant-form-item-control-input {
                    .ant-form-item-control-input-content {
                      .ant-input {
                        padding: 0 1rem;
                        margin-bottom: 0.5rem;
                        border-radius: 0.5rem !important;
                        font-size: 1.4rem;
                        border: 1px solid $color-dark-grey-4;
                        font-family: $font-primary;
                        width: 100%;
                        outline: none;
                        color: $color-black;
                        box-shadow: none;
                        display: flex;
                        align-items: center;
                        line-height: normal;
                        min-height: 3.8rem;
                        &::placeholder {
                          color: $color-placeholder;
                        }
                        @include respond(phone-large) {
                          font-size: 2rem;
                          height: 5rem;
                          padding: 0 1.5rem;
                        }
                      }
                    }
                  }
                  .ant-form-item-explain-error {
                    min-height: auto;
                    div {
                      width: auto;
                      font-size: 1.4rem;
                      font-family: $font-primary;
                      color: red;
                      line-height: normal;
                      @include respond(phone-large) {
                        font-size: 2rem;
                      }
                    }
                  }
                }
              }
            }
            &--skeleton {
              margin: 0 0 2rem;
              .ant-skeleton-content {
                .ant-skeleton-title {
                  height: 2rem;
                  margin: 0 0 0.8rem;
                }
                .ant-skeleton-paragraph {
                  margin: 0;
                  li {
                    margin: 0;
                    height: 3.8rem;
                  }
                }
              }
            }
            &::-webkit-scrollbar {
              width: 0.4rem;
              height: 0.4rem;
            }

            &::-webkit-scrollbar-track {
              background-color: transparent;
              border-radius: 0.8rem;
            }

            &::-webkit-scrollbar-thumb {
              background-color: $color-primary;
              border-radius: 0.8rem;
            }
          }
          &__footer {
            padding: 1rem 2.5rem 2.5rem;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            .ant-btn {
              font-size: 1.6rem;
              font-family: $font-primary-medium;
              width: 10rem;
              display: block;
              height: 4rem;
              border: none;
              background-color: $color-primary;
              color: $color-white;
              padding: 0;
              span {
                line-height: normal;
              }
              .anticon {
                .anticon-spin {
                  font-size: 2rem;
                  color: $color-primary;
                }
              }
              @include respond(phone-large) {
                font-size: 2.2rem;
                height: 4.8rem;
                width: 12rem;
                .anticon {
                  .anticon-spin {
                    font-size: 2.4rem;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
